export default __webpack_public_path__ + "static/media/topography.78635f54.svg";